export default __webpack_public_path__ + "static/media/image-001.0f51d498.png";